import Wrapper from '../../layouts/Wrapper/Wrapper';
import Headers from '../../core/Headers/Headers';
import ApprovalQueue from './Queue/Queue';

const ApprovalQueueContainer = () => {
  return (
    <Wrapper additionalClasses="flex-col items-start" pageTitle="Approvals">
      <Headers headingContent="Approvals" isSignOutButton headerWrapperClasses="border-none" />
      <ApprovalQueue />
    </Wrapper>
  );
};

export default ApprovalQueueContainer;
